import { __decorate } from "tslib";
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedHttp } from '../../../../services/http-client.service';
import { UtilityService } from '../../../../services/utility.service';
import { AuthService } from '../../../../services/auth.service';
import { WebClientService } from '../../../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Confirm Component
 */
let ConfirmBuyComponent = class ConfirmBuyComponent {
    constructor(httpClient, route, convertor, auth, webSettingsService, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.route = route;
        this.convertor = convertor;
        this.auth = auth;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.confirmData = {};
        this.status = 'registred_user';
        this.userData = {};
        this.textColor = '';
        this.accentColor = '';
        this.secondColor = '';
        this.backColor = '';
        this.mainColor = '';
        this.orderType = 'buy';
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
        });
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.userType = this.userData.user_type_id.type;
        this.status = this.userType + '_user';
        this.isUser = false;
        this.isIndividual = this.userData.is_company_user ? 0 : 1;
    }
    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.orderId = params['orderId'];
            this.getOrderData(this.orderId + '');
        });
    }
    ngAfterViewInit() {
    }
    getOrderData(oid) {
        if (oid !== '') {
            this.httpClient.get('market/user/orders/' + oid).subscribe((data) => {
                this.confirmData = data;
                if (!('bank_payment_details' in this.confirmData)) {
                    this.confirmData.bank_payment_details = null;
                }
                this.meanOfPayment = this.confirmData.mean_of_payment.verbose_id;
                this.nameOfCurrency = this.confirmData.cryptocurrency;
                this.convertor.convertToShortcut(this.nameOfCurrency).then(result => {
                    this.currency = result + '';
                    this.httpClient.get('market/feesandlimits?ecurrency=' + this.currency + '&mop=' + this.meanOfPayment + '&user_type=' + this.userType + '&order_type=buy' + '&is_individual=' + this.isIndividual + '&chain=' + this.confirmData.ecurrency_chain['chain']['name']).subscribe((data) => {
                        this.provision = data['buy'][this.currency][this.meanOfPayment][this.userType].fee;
                    });
                });
            });
        }
    }
    confirmedCardTransaction(isCard) {
        if (isCard) {
            this.cardPaymentDetails.paymentRequestDetails(this.orderId);
        }
    }
};
ConfirmBuyComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: UtilityService },
    { type: AuthService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
__decorate([
    ViewChild('cardPaymentDetails', { static: true })
], ConfirmBuyComponent.prototype, "cardPaymentDetails", void 0);
ConfirmBuyComponent = __decorate([
    Component({
        selector: 'ecd-confirm',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./confirm.component.html")).default
    })
], ConfirmBuyComponent);
export { ConfirmBuyComponent };
